__turbopack_context__.v({
  "header": "_2JP3nG_header",
  "header__links": "_2JP3nG_header__links",
  "header__logo": "_2JP3nG_header__logo",
  "header__section": "_2JP3nG_header__section",
  "header__section--active": "_2JP3nG_header__section--active",
  "header__sections": "_2JP3nG_header__sections",
});
